<template>
    <div v-if="localvalue">

        <div v-if="localvalue.consumptions" class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_alchohol_consumption') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_alcohol)].amount" :hasLabel="false" :options="options['consumption_type.alcohol'].amount" @input="handleChange" name="alcoholAmount" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_alcohol)].consumption_choice.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_alcohol)].consumption_choice" :hasLabel="false" :options="options['consumption_type.alcohol'].consumption_choice" @input="handleChange" name="alcoholConsumptionChoice" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_alcohol)].amount.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                </div>
            </div>
        </div>

        <div v-if="localvalue.consumptions" class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_strong_alchohol_consumption') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_spirits)].amount" :hasLabel="false" :options="options['consumption_type.spirits'].amount" @input="handleChange" name="spiritsAmount" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_spirits)].consumption_choice.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_spirits)].consumption_choice" :hasLabel="false" :options="options['consumption_type.spirits'].consumption_choice" @input="handleChange" name="spiritsConsumptionChoice" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_spirits)].amount.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                </div>
            </div>
        </div>

        <div v-if="localvalue.consumptions" class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_coffee_consumption') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_caffeine)].amount" :hasLabel="false" :options="options['consumption_type.caffeine'].amount" @input="handleChange" name="caffeineAmount" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_caffeine)].consumption_choice.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_caffeine)].consumption_choice" :hasLabel="false" :options="options['consumption_type.caffeine'].consumption_choice" @input="handleChange" name="caffeineConsumptionChoice" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_caffeine)].amount.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_coffee_time_consumption') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <div class="col-6 mb-16">
                        <el-timepicker v-model="last_caffeine" @change="() => { localvalue.last_caffeine = (last_caffeine.HH && last_caffeine.mm) ? `${last_caffeine.HH}:${last_caffeine.mm}` : null; handleChange() }" :top="true" :minute-interval="15" :hide-clear-button="true"></el-timepicker>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="localvalue.consumptions" class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_sweet_drink_consumption') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_sugar)].amount" :hasLabel="false" :options="options['consumption_type.sugar'].amount" @input="handleChange" name="sugarAmount" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_sugar)].consumption_choice.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                    <el-select class="col-6" v-model="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_sugar)].consumption_choice" :hasLabel="false" :options="options['consumption_type.sugar'].consumption_choice" @input="handleChange" name="sugarConsumptionChoice" :rule="localvalue.consumptions[localvalue.consumptions.findIndex(c => c.consumption_type_id === consumptionTypes_sugar)].amount.value !== null ? 'required' : ''" :placeholder="$t('general.fill')"></el-select>
                </div>
            </div>
        </div>

        <div class="row mb-44">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_sweet_drink_time_consumption') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <div class="col-6 mb-16">
                        <el-timepicker v-model="last_sugar" @change="() => { localvalue.last_sugar = (last_sugar.HH && last_sugar.mm) ? `${last_sugar.HH}:${last_sugar.mm}` : null; handleChange() }" :top="true" :minute-interval="15" :hide-clear-button="true"></el-timepicker>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-32">
            <div class="col-12">
                <h6 class="fw-b"> {{ $t('pages.profile.habits_avg') }}</h6>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_tv_time') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <div class="col-6 mb-16">
                        <el-timepicker v-model="recreation_before_sleep" @change="() => { localvalue.recreation_before_sleep = (recreation_before_sleep.HH && recreation_before_sleep.mm) ? `${recreation_before_sleep.HH}:${recreation_before_sleep.mm}` : null; handleChange() }" :top="true" :minute-interval="15" :hide-clear-button="true"></el-timepicker>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-4">
                <p class="mb-0">{{ $t('pages.profile.habits_mail_check_time') }}</p>
            </div>
            <div class="col-12 col-xl-4">
                <div class="form-row">
                    <div class="col-6 mb-16">
                        <el-timepicker v-model="notification_check_after_awaken" @change="() => { localvalue.notification_check_after_awaken = (notification_check_after_awaken.HH && notification_check_after_awaken.mm) ? `${notification_check_after_awaken.HH}:${notification_check_after_awaken.mm}` : null; handleChange() }" :top="true" :minute-interval="15" :hide-clear-button="true"></el-timepicker>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { _ } from 'vue-underscore'
_.mixin(require('underscore.deepclone'));


import { ElSelect, ElTimepicker } from '@/components/forms'

export default {
    inject: ['$validator'],
    components: { ElSelect, ElTimepicker },
    name: 'el-habits',
    props: {
        value: {
            type: Object
        }
    },
    data() {
        return {
            localvalue: null,

            last_caffeine: { HH: null, mm: null },
            last_sugar: { HH: null, mm: null },
            recreation_before_sleep: { HH: null, mm: null },
            notification_check_after_awaken: { HH: null, mm: null },

            options: {
                'consumption_type.alcohol': {
                    amount: [{ label: this.$t('pages.profile.amount.weekly'), value: 1 }, { label: this.$t('pages.profile.amount.daily'), value: 2 }, { label: this.$t('pages.profile.amount.never'), value: 3 }],
                    consumption_choice: [{ label: this.$t('habits.beer'), value: 'beer' }, { label: this.$t('habits.wine'), value: 'wine' }, { label: this.$t('habits.not_applicable'), value: 'nvt' }]
                },
                'consumption_type.spirits': {
                    amount: [{ label: this.$t('pages.profile.amount.weekly'), value: 1 }, { label: this.$t('pages.profile.amount.daily'), value: 2 }, { label: this.$t('pages.profile.amount.never'), value: 3 }],
                    consumption_choice: [{ label: this.$t('habits.strong_beer'), value: 'beer' }, { label: this.$t('habits.liquor'), value: 'liquor' }, { label: this.$t('habits.not_applicable'), value: 'nvt' }]
                },
                'consumption_type.caffeine': {
                    amount: [{ label: this.$t('pages.profile.amount.one_x', { x: this.$tc('pages.profile.amount.cup', 1) }), value: 1 }, { label: this.$t('pages.profile.amount.two_four_x', { x: this.$tc('pages.profile.amount.cup', 2) }), value: 2 }, { label: this.$t('pages.profile.amount.over_four_x', { x: this.$tc('pages.profile.amount.cup', 2) }), value: 3 }, { label: this.$t('pages.profile.amount.never'), value: 4 }],
                    consumption_choice: [{ label: this.$t('habits.coffee'), value: 'coffee'}, { label: this.$t('habits.tea'), value: 'thee' }, { label: this.$t('habits.caffeine'), value: 'cafeïne' }, { label: this.$t('habits.not_applicable'), value: 'nvt' }]
                },
                'consumption_type.sugar': {
                    amount: [{ label: this.$t('pages.profile.amount.one_x', { x: this.$tc('pages.profile.amount.glass', 1) }), value: 1 }, { label: this.$t('pages.profile.amount.two_four_x', { x: this.$tc('pages.profile.amount.glass', 2) }), value: 2 }, { label: this.$t('pages.profile.amount.over_four_x', { x: this.$tc('pages.profile.amount.glass', 2) }), value: 3 }, { label: this.$t('pages.profile.amount.never'), value: 5 }],
                    consumption_choice: [{ label: this.$t('habits.soda'), value: 'soda' }, { label: this.$t('habits.energy_drink'), value: 'energy_drink' }, { label: this.$t('habits.not_applicable'), value: 'nvt' }]
                }
            }
        }
    },
    mounted() {
        this.$store.dispatch('general/consumptionTypes').then(() => {
            this.localvalue = this.parseConsumptions(this.value)
        })
    },
    methods: {
        handleChange() {
            let result = _.deepClone(this.localvalue)
            let valid_consumptions = result.consumptions
                .filter((c) => c.amount.value !== null || c.consumption_choice.value !== null)
                .map((c) => { return { amount: c.amount.value, consumption_choice: c.consumption_choice.value, consumption_type_id: c.consumption_type_id } })

            result.consumptions = valid_consumptions
            this.$emit('input', result)
            this.$nextTick().then(() => {
                this.$validator.validateAll()
            })
        },

        parseConsumptions(value) {
            let result = _.deepClone(value)
            let result_consumptions = []

            this.consumptionTypes.forEach((type) => {
                let consumption_index = result.consumptions.findIndex(c => {
                    return c.consumption_type_id === type.id
                })

                if (consumption_index !== -1) {
                    let consumption = result.consumptions[consumption_index]
                    let type = this.consumptionTypes.find(type => type.id === consumption.consumption_type_id).name
                    let amount = this.options[type].amount.find((o) => o.value === consumption.amount)
                    let consumption_choice = this.options[type].consumption_choice.find((o) => o.value === consumption.consumption_choice)

                    result_consumptions.push({
                        amount: { value: consumption.amount, label: amount ? amount.label : null },
                        consumption_choice: { value: consumption.consumption_choice, label: consumption_choice ? consumption_choice.label : '' },
                        consumption_type_id: consumption.consumption_type_id
                    })
                } else {
                    result_consumptions.push({
                        amount: { value: null, label: '' },
                        consumption_choice: { value: null, label: '' },
                        consumption_type_id: type.id
                    })
                }
            })

            result.consumptions = result_consumptions

            this.last_caffeine = this.value.last_caffeine ? { HH: this.$moment(this.value.last_caffeine, 'HH:mm:ss').format('HH'), mm: this.$moment(this.value.last_caffeine, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }
            this.last_sugar = this.value.last_sugar ? { HH: this.$moment(this.value.last_sugar, 'HH:mm:ss').format('HH'), mm: this.$moment(this.value.last_sugar, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }
            this.recreation_before_sleep = this.value.recreation_before_sleep ? { HH: this.$moment(this.value.recreation_before_sleep, 'HH:mm:ss').format('HH'), mm: this.$moment(this.value.recreation_before_sleep, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }
            this.notification_check_after_awaken = this.value.notification_check_after_awaken ? { HH: this.$moment(this.value.notification_check_after_awaken, 'HH:mm:ss').format('HH'), mm: this.$moment(this.value.notification_check_after_awaken, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }

            return result
        }
    },
    computed: {
        consumptionTypes() {
            return this.$store.getters['general/consumptionTypes']
        },
        consumptionTypes_alcohol() { return this.consumptionTypes.find(type => type.name === 'consumption_type.alcohol').id },
        consumptionTypes_spirits() { return this.consumptionTypes.find(type => type.name === 'consumption_type.spirits').id },
        consumptionTypes_caffeine() { return this.consumptionTypes.find(type => type.name === 'consumption_type.caffeine').id },
        consumptionTypes_sugar() { return this.consumptionTypes.find(type => type.name === 'consumption_type.sugar').id }
    },
    watch: {
        value() {
            this.localvalue = this.parseConsumptions(this.value)
        }
    }
}
</script>
